import styled from "styled-components";

export const Body =styled.div`
height:90vh;
margin-top:0;
display:flex;

@media only screen and (min-width: 700px) {
    padding-left:100px;
}

`;

export const Left =styled.div`

width:calc( 60% - 100px );
display:flex;
align-items:center;
justify-content:center;

div{
    margin-top:50px;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;

.butbox{
    flex-direction:row;

}
}

h1{
    padding:2px;
    margin-top:0;
    color:white;
    line-height:0.6;
    font-size:3rem;
    font-family:Helvetica ;

}

h3{
    padding:2px;
    margin-top:0;
    color:#6c63ff;
    line-height:0.6;
    font-size:1.8rem;
    font-family: "Source Code Pro";

    overflow: hidden;
    white-space: nowrap;
    border-right: 3px solid #6c63ff;  /* cursor */
    width: 0;
    animation: typing 3s steps(30, end) forwards,
               blink 0.7s step-end infinite;
  }

  @keyframes typing {
    from { width: 0 }
    to { width: 72% }
  }

  @keyframes blink {
    50% { border-color: transparent }
  }

@media only screen and (max-width: 900px) {
width:100%;
}

@media only screen and (max-width: 700px) {    
    h1{
        font-size:1.8rem;
        text-align:center;
    }
        h3{
        font-size:1.2rem;
        text-align:center;
    }
}

`

export const ButtonBox = styled.div`
  gap:50px;

  button{
    width:150px;
    height:40px;
    border-radius:32px;
    border:2px solid  #00e0ff;
    background:linear-gradient(to bottom right  ,#00e0ff,#00b7ff,#004fff);
    color:white;
    font-weight:bold;
    cursor:pointer;
    transition: all 0.3s ease-in-out;

    /* Static Glow */
    box-shadow: 0 0 10px rgba(0, 224, 255, 0.7),
                0 0 20px rgba(0, 183, 255, 0.5);

    /* Smooth transition on hover */
    &:hover {
      box-shadow: 0 0 5px rgba(0, 224, 255, 1),
                  0 0 15px rgba(0, 183, 255, 0.8),
                  0 0 30px rgba(0, 79, 255, 0.6);
      transform: scale(1.05);
    }


  @media only screen and (max-width: 700px) {
    gap:20px;
  }
`;


export const Right =styled.div`

width:40%;
display:flex;
align-items:center;
justify-content:center;

img{
    height:50%;
    filter: drop-shadow(4px 7px 0px rgba(108, 122, 137,.7));

}

@media only screen and (max-width: 900px) {
    display:none;
    }

`